// Tailwind v2: no slash opacity, use dark-card/dark-bg/dark-text/dark-border tokens.

import { fitnessProfileSurfaceCardClassName, fitnessProfileFormErrorClassName, readingModalInputClassName } from '../FitnessProfile/shared/fitnessProfileReadingStyles';

export const aiTrainerCardClassName = fitnessProfileSurfaceCardClassName;

export const aiTrainerErrorClassName = fitnessProfileFormErrorClassName;

export const aiTrainerInputClassName = readingModalInputClassName;

export const aiTrainerMutedTextClassName = 'text-sm text-gray-600 dark:text-dark-text-secondary';

export const aiTrainerHeadingClassName = 'text-gray-900 dark:text-dark-text';

export const aiTrainerSubheadingClassName = 'text-sm text-gray-600 dark:text-dark-text-secondary';

export const aiTrainerPrimaryButtonClassName =
	'rounded-xl bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-700 dark:bg-blue-600 dark:hover:bg-blue-500 disabled:opacity-60 transition';

export const aiTrainerSecondaryButtonClassName =
	'rounded-xl border border-gray-300 dark:border-dark-border px-4 py-2 text-sm font-medium text-gray-700 dark:text-dark-text hover:bg-gray-50 dark:hover:bg-dark-bg disabled:opacity-60 transition';

export const aiTrainerLinkClassName =
	'shrink-0 text-sm font-medium text-blue-600 dark:text-blue-400 hover:underline';

export const PERSONA_ACCENT = {
	tough_love:
		'border-orange-500 bg-orange-50 text-gray-900 dark:bg-dark-bg dark:border-orange-500 dark:text-dark-text',
	drill_sergeant:
		'border-red-600 bg-red-50 text-gray-900 dark:bg-dark-bg dark:border-red-500 dark:text-dark-text',
	soft_spoken:
		'border-green-500 bg-green-50 text-gray-900 dark:bg-dark-bg dark:border-green-500 dark:text-dark-text',
	hype_coach:
		'border-yellow-500 bg-yellow-50 text-gray-900 dark:bg-dark-bg dark:border-yellow-500 dark:text-dark-text',
	science_nerd:
		'border-indigo-500 bg-indigo-50 text-gray-900 dark:bg-dark-bg dark:border-indigo-400 dark:text-dark-text',
	accountability_partner:
		'border-blue-500 bg-blue-50 text-gray-900 dark:bg-dark-bg dark:border-blue-500 dark:text-dark-text'
};

export const PERSONA_BORDER = {
	tough_love: 'border-l-orange-500',
	drill_sergeant: 'border-l-red-500',
	soft_spoken: 'border-l-green-500',
	hype_coach: 'border-l-yellow-500',
	science_nerd: 'border-l-indigo-400',
	accountability_partner: 'border-l-blue-500'
};

export const PERSONA_PICKER_SELECTED = {
	tough_love: 'border-orange-500 bg-orange-50 dark:bg-dark-bg dark:border-orange-500 ring-2 ring-blue-500',
	drill_sergeant: 'border-red-600 bg-red-50 dark:bg-dark-bg dark:border-red-500 ring-2 ring-blue-500',
	soft_spoken: 'border-green-500 bg-green-50 dark:bg-dark-bg dark:border-green-500 ring-2 ring-blue-500',
	hype_coach: 'border-yellow-500 bg-yellow-50 dark:bg-dark-bg dark:border-yellow-500 ring-2 ring-blue-500',
	science_nerd: 'border-indigo-500 bg-indigo-50 dark:bg-dark-bg dark:border-indigo-400 ring-2 ring-blue-500',
	accountability_partner: 'border-blue-500 bg-blue-50 dark:bg-dark-bg dark:border-blue-500 ring-2 ring-blue-500'
};

export const PERSONA_PICKER_IDLE =
	'border-gray-300 dark:border-dark-border bg-white dark:bg-dark-card hover:border-blue-400 dark:hover:border-blue-500';
